import React from 'react'
import c from 'classnames'
import { connect } from 'react-redux'
import { Flipper, Flipped } from 'react-flip-toolkit'
import isNull from 'lodash/isNull'

import Tag from 'discada/dist/Tag'

import { getReactionStats } from 'selectors/naughtySelectors'

import { INTENTS_EMOJI, INTENTS_LABELS } from 'reducers/quoteReducers'

import './ReactionStats.scss'

export function ReactionControl({
  reaction,
  className,
  onClick = () => {},
  count,
}) {
  return (
    <div className={c('reaction-stat', className)} onClick={onClick}>
      {INTENTS_EMOJI[reaction]} {INTENTS_LABELS[reaction]}{' '}
      {!isNull(count) && <Tag color="primary">{count}</Tag>}
    </div>
  )
}

export function ReactionStats(props) {
  let { reactions } = props

  return (
    <Flipper
      className="reaction-stats-wrapper"
      flipKey={JSON.stringify(reactions)}
    >
      {Object.keys(reactions)
        .filter(k => reactions[k])
        .map(k => (
          <Flipped key={k} flipId={k} stagger>
            <ReactionControl reaction={k} count={reactions[k]} />
          </Flipped>
        ))}
    </Flipper>
  )
}

export function ReactionGauge({ reactions = [], classname, onClick }) {
  return (
    <span
      className={c('frikin-reaction-gauge', 'reaction-stat')}
      onClick={onClick}
    >
      {reactions.map(r => (
        <span key={r}>{INTENTS_EMOJI[r]}</span>
      ))}
    </span>
  )
}

function mapStateToProps(state, op) {
  return { ...op, reactions: getReactionStats(state) }
}

export default connect(mapStateToProps)(ReactionStats)
